<template>
  <div class="register-box">
    <div class="register-tips">员工请先完成注册，否则数据不会保存</div>
    <div class="form-content">
      <div class="form-item">
        <div class="form-lable">
          <i>* </i>
          <label>公司名称</label>
        </div>
        <div style="color: #333">{{ businessName }}</div>
      </div>
      <div class="form-item" id="departmentPicker">
        <div class="form-lable">
          <i>* </i>
          <label>部门</label>
        </div>
        <div class="department-name" :style="departmentName ? 'color:#333333' : 'color:#cccccc'">
          {{ departmentName || "请选择部门" }}
        </div>
        <img
          class="next-icon"
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/bd1b7bf0-d0a0-4480-80b5-3861d087849f.png"
        />
      </div>
      <div class="form-item">
        <div class="form-lable">
          <i>* </i>
          <label>职位</label>
        </div>
        <input
          type="text"
          v-model="form.job"
          placeholder="请输入职位名称"
          maxlength="10"
        />
      </div>
      <div class="form-item" style="margin-top: 15px">
        <div class="form-lable">
          <i>* </i>
          <label>员工姓名</label>
        </div>
        <input
          type="text"
          v-model="form.empName"
          placeholder="请输入员工姓名"
          maxlength="10"
        />
      </div>
      <div class="form-item">
        <div class="form-lable">
          <i>* </i>
          <label>手机号</label>
        </div>
        <input
          type="text"
          maxlength="11"
          id="phone"
          name="phone"
          onBlur="this.value=this.value.replace(/[, ]/g,'')"
          onkeyup="this.value=this.value.replace(/[, ]/g,'')"
          placeholder="请输入手机号"
        />
      </div>
      <div class="form-item">
        <div class="form-lable">
          <i>* </i>
          <label>验证码</label>
        </div>
        <input
          type="text"
          id="verify"
          name="verify"
          v-model="form.verifyCode"
          maxlength="8"
          placeholder="请输入验证码"
          autocomplete="off"
        />
        <span class="verification-btn" id="send-verify" @click="sendVerify"
          >发送验证码</span
        >
        <span
          class="verification-btn"
          id="reset-verify"
          style="display: none"
        ></span>
        <!-- <div class="verification-btn">获取验证码</div> -->
      </div>
    </div>
    <div class="submit-btn" @click="registerBtn()">完成注册</div>
  </div>
</template>

<script>
import api from "api";
import utils from "@utils/index";
import wx from "weixin-js-sdk";

import { Toast } from "mint-ui";
import weui from "../../vendor/weui/weui.js";
import "../../vendor/weui/weui.css";

export default {
  name: "employee-register",
  components: {},
  data() {
    return {
      id: utils.getUrlParam("id") || "", //活动id
      businessName: utils.getUrlParam("businessName") || "",
      businessId: utils.getUrlParam("businessId") || "",
      matched: utils.getUrlParam("matched") || "",
      parentTimeStamp: utils.getUrlParam("parentTimeStamp"), //用于重新获取标识
      departmentName: "",
      departmentTree: [],
      departmentId: "", //选中的部门id
      form: {
        job: "",
        empName: "",
        verifyCode: "",
      },
      time: 60, //定时器
      timer: null,
      orginPage: utils.getUrlParam("orginPage") || "", //来源页面 externalShare-小程序活动外部分享进入 为空则由活动内部分享进入
    };
  },
  created() {
  },
  mounted() {
    this.getDepartmentTreeAll();
  },
  methods: {
    /**
     * 初始化部门picker选择
     */
    initPicker(list, level) {
      let self = this;
      document
        .querySelector("#departmentPicker")
        .addEventListener("click", function () {
          weui.picker(list, {
            depth: level,
            defaultValue: [0, 0, 0, 0, 0, 0].slice(0,level),
            onChange: function (result) {
              console.log(result);
            },
            onConfirm: function (result) {
              console.log(result);
              let item = {};
              let i = result.length - 1;
              console.log(i);
              for (i; i >= 0; i--) {
                item = result[i];
                if (item.value) {
                  break;
                }
              }
              self.departmentId = item.value;
              self.departmentName = item.label;
              console.log("选中的==", item);
            },
            id: "cascadePicker",
            title: "部门选择",
          });
        });
    },
    //获取部门树
    getDepartmentTreeAll() {
      api
        .request("getDepartmentTreeAll", {
          businessId: this.businessId,
        })
        .then((result) => {
          if (result.status == 0) {
            this.departmentTree = result.data;
            if(this.departmentTree.length > 0){
              this.departmentId = this.departmentTree[0].id;
              this.departmentName = this.departmentTree[0].label;
            }
            let pickerLevel = this.handleDepartmentData(this.departmentTree);
            this.supplementDepartmentData(this.departmentTree, pickerLevel);
            this.initPicker(this.departmentTree, pickerLevel);
          } else {
            console.log("获取部门树失败");
          }
        });
    },
    /**
     * 处理部门列表数据
     * @param tree 数据源
     * @param level 层级
     */
    handleDepartmentData(tree, level = 1) {
      tree.map((item) => {
        item.value = item.id;
        if (item.children.length > 0) {
          let _level = this.handleDepartmentData(item.children, level + 1);
          if (_level > level) {
            level = _level;
          }
        }
        return item;
      });
      return level;
    },
    /**
     * 补全部门列表数据
     */
    supplementDepartmentData(tree, maxLevel) {
      return tree.map((item) => {
        item.value = item.id;
        if (item.level < maxLevel) {
          item.children.unshift({
            label: "-",
            level: item.level + 1,
            children: [],
            id: "",
            value: "",
          });
        }
        item.children = this.supplementDepartmentData(item.children, maxLevel);
        return item;
      });
    },

    //获取验证码
    sedCode() {
      var self = this,
        phone = $("#phone"),
        sendVerifyCode = $("#send-verify"),
        resetVerifyCode = $("#reset-verify");

      if (!phone.val()) {
        self.$message.error("手机号不能为空");
        return;
      }
      if (!phone.val() && !self.phoneReg.test(phone.val())) {
        self.$message.error("请输入正确手机号");
        return;
      }
      api.request(
        "getVerificationCode",
        {
          type: 10,
          phone: phone.val(),
          businessId: this.businessId,
        },
        function (result) {
          if (result.status == 0) {
            sendVerifyCode.hide();
            resetVerifyCode.html(self.time + "s重新发送").show();
            self.timer = setInterval(function () {
              if (self.time == 0) {
                sendVerifyCode.html("重新发送").show();
                resetVerifyCode.hide();
                clearInterval(self.timer);
                self.time = 60;
                return false;
              }
              self.time = self.time - 1;
              resetVerifyCode.html(self.time + "s重新发送");
            }, 1000);
          } else {
            self.$message.error(result.message);
          }
        }
      );
    },
    //发送验证码
    sendVerify() {
      this.sedCode();
    },
    departmentChange(value) {
      this.departmentId = value[value.length - 1];
    },
    //注册
    registerBtn() {
      var phone = $("#phone");
      //验证
      if (!this.departmentId) {
        this.$message.error("部门不能为空");
        return;
      }
      if (!this.form.job) {
        this.$message.error("职位不能为空");
        return;
      }
      if (!this.form.empName) {
        this.$message.error("员工姓名不能为空");
        return;
      }
      if (!phone.val()) {
        this.$message.error("手机号不能为空");
        return;
      }
      if (!this.form.verifyCode) {
        this.$message.error("验证码不能为空");
        return;
      }
      let self = this,
        _options = {
          businessId: this.businessId,
          name: this.form.empName,
          phone: phone.val(),
          deptId: this.departmentId,
          job: this.form.job,
          code: this.form.verifyCode,
          fromType: 2,
          fromId: this.id, //活动id
        };
      api.request("employeeRegister", _options).then((result) => {
        if (result.status == 0) {
          Toast("注册成功");
          //活动分享外部进入 则返回小程序页面
          if(self.orginPage === 'externalShare'){
            wx.miniProgram.navigateBack();
          }else{
            //小程序重新获取转发标识
            if (self.matched == "true") {
              self.getForwardKey();
            } else {
              //清除转发标识，触发活动中重新获取
              sessionStorage.removeItem("forwardKey");
              window.location.href = document.referrer;
            }
          }
        } else {
          Toast("注册失败");
        }
      });
    },
    //获取转发标识
    getForwardKey() {
      var self = this,
        _options = {
          clientType: this.matched == "true" ? "weapp" : "wx",
          rootUserId: utils.getSessionStorage("rootUserId"),
          forwardKey: utils.getSessionStorage("forwardKey"), // 上级转发key
          relationId: this.id, // 活动id
          sourceType: 2, //来源 2:活动，5：海报,
          indexType: "user_browse",
          timeStamp: parseFloat(
            utils.getSessionStorage("accessStartTime") || 0
          ),
          parentTimeStamp: this.parentTimeStamp || "",
        };
      api.request("getQueryForwardKey", _options).then((result) => {
        if (result.status == 0) {
          //重新赋值标识
          sessionStorage.setItem("forwardKey", result.data.forwardKey);
          sessionStorage.setItem(
            "parentForwardKey",
            result.data.parentForwardKey
          );
          sessionStorage.setItem("rootUserId", result.data.rootUserId);
          //跳转小程序
          wx.miniProgram.navigateTo({
            url:
              "/pages-user/share-activity/share-activity?" +
              [
                "id=" + (self.id || ""),
                "copywriting=" +
                  encodeURIComponent(
                    JSON.stringify(utils.getUrlParam("copywriting"))
                  ),
                "qrcodeImg=" + utils.getUrlParam("qrcodeImg") || "",
                "rootUserId=" + result.data.rootUserId,
                "parentForwardKey=" + result.data.parentForwardKey,
                "forwardKey=" + result.data.forwardKey,
                "cardId=" + (utils.getQueryString("cardId") || ""),
                "timeStamp=" +
                  parseFloat(utils.getSessionStorage("accessStartTime") || 0),
                "parentTimeStamp=" + self.parentTimeStamp,
              ].join("&"),
          });
        } else {
          console.log("重新获取标识失败");
        }
      });
    },
  },
};
</script>
<style sceped>
i {
  font-style: inherit;
  color: #f0142d;
}

.next-icon {
  width: 0.2rem;
  height: 0.4rem;
  flex-shrink: 0;
  margin-right: 0.1rem;
}

.register-box {
  height: 100vh;
  background-color: #f7f8fa;
  overflow: hidden;
  touch-action: none;
}
.register-tips {
  width: 100%;
  height: 74px;
  line-height: 74px;
  font-size: 26px;
  color: #faab0c;
  padding-left: 30px;
  background-color: #fffbe8;
}
.form-item {
  display: flex;
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  color: #333333;
  padding: 0 18px 0 30px;
  border-bottom: 1px solid #ebedf0;
  background-color: #fff;
  flex-flow: row nowrap;
  align-items: center;
  overflow: hidden;
}
.form-lable {
  width: 150px;
  margin-right: 26px;
}
.form-item > div:last-child {
  color: #cccccc;
}
.department-name{
  color: #cccccc;
  text-overflow: ellipsis;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
}
.form-item > input {
  width: 330px;
  border: 0;
}
input::-webkit-input-placeholder {
  color: #cccccc;
}
.form-item .verification-btn {
  width: auto !important;
  color: #333333 !important;
  margin-left: 10px;
}
.register-box .submit-btn {
  width: 686px;
  height: 80px;
  font-size: 28px;
  text-align: center;
  line-height: 80px;
  color: #fff;
  background-color: #2E6AF8;
  border-radius: 8px;
  margin: 40px auto;
  cursor: pointer;
}
/* 部门 */
.form-item > span {
  width: 558px !important;
}
.form-item > span input {
  height: 100%;
  border: none !important;
  font-size: 30px;
  color: #ccc;
  padding: 0;
}
.form-item .ant-cascader-picker-label {
  padding: 0;
}
.form-item .ant-cascader-picker:focus .ant-cascader-input {
  border-color: transparent !important;
  box-shadow: none !important;
}
.form-item .ant-cascader-picker-label {
  max-width: 488px;
  height: 100px;
  top: 10px;
  font-size: 30px;
  line-height: 100px;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 8px !important;
}
.form-item .ant-input:focus,
.form-item .ant-input:hover {
  border-color: transparent !important;
  box-shadow: none !important;
}
.form-item .anticon svg,
.form-item .ant-cascader-picker-arrow,
.ant-cascader-picker-clear {
  width: 24px;
  height: 24px;
  top: 42%;
  transform: rotate(135deg);
}
.form-item .ant-cascader-picker-arrow.ant-cascader-picker-arrow-expand {
  transform: rotate(225deg) !important;
}
.ant-cascader-menus {
  font-size: 24px;
}
.ant-cascader-menu-item {
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 40px;
}
.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon,
.ant-cascader-menu-item-loading-icon {
  font-size: 20px !important;
  right: 5px;
  line-height: 40px;
}
</style>